import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { ActiveUsersResponse } from '../types/ActiveUser';

export default function useFetchActiveUsers() {
  const query = qs.stringify('', { arrayFormat: 'brackets' });
  return useQuery({
    queryKey: ['activeUsers', query, 1, ''],
    queryFn: async () => {
      const response = await fetch(`/agent/api/active_users.json?${query}`);
      const data: ActiveUsersResponse = await response.json();

      return data;
    },
  });
}
